module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctrl-container",
    style: (_vm.ctrlContainerStyle)
  }, [_c('span', {
    staticClass: "title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))])]), _c('div', {
    staticClass: "divider"
  }), _c('ul', {
    attrs: {
      "id": "ctrl"
    }
  }, [_c('li', {
    staticClass: "ctrl-item"
  }, [_c('h3', [_vm._v("Demo 宽度设置：" + _vm._s((_vm.demoWidth + "%")))]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number.lazy",
      value: (_vm.demoWidth),
      expression: "demoWidth",
      modifiers: {
        "number": true,
        "lazy": true
      }
    }],
    staticClass: "width-input",
    attrs: {
      "type": "range",
      "min": "20",
      "max": "75"
    },
    domProps: {
      "value": (_vm.demoWidth)
    },
    on: {
      "change": [function($event) {
        _vm.demoWidth = _vm._n($event.target.value)
      }, _vm.widthOnChange],
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _c('li', {
    staticClass: "ctrl-item"
  }, [_c('h3', [_vm._v("弹性容器的属性说明")]), _c('ul', _vm._l((_vm.containerDescArr), function(desc) {
    return _c('li', [_vm._v(_vm._s(desc))])
  }))]), _c('li', {
    staticClass: "ctrl-item"
  }, [_vm._m(0), _c('div', {
    staticClass: "demo-props"
  }, _vm._l((_vm.containerFlexPropArr), function(item) {
    return _c('div', {
      staticClass: "container-prop-item"
    }, [_c('span', [_vm._v(_vm._s(item.name))]), _vm._l((item.itemValues), function(value) {
      return _c('div', {
        staticClass: "ctrl-prop-item"
      }, [_c('input', {
        attrs: {
          "type": "radio",
          "id": ((item.prefix) + "-" + value),
          "value": "value"
        },
        domProps: {
          "checked": _vm.demoProps[item.prefix] === value
        },
        on: {
          "change": function($event) {
            _vm.propOnChange(( _obj = {}, _obj[item.prefix] = value, _obj ))
            var _obj;
          }
        }
      }), _c('label', {
        attrs: {
          "for": ((item.prefix) + "-" + value)
        }
      }, [_vm._v(_vm._s(value))])])
    })], 2)
  }))]), _c('li', {
    staticClass: "ctrl-item"
  }, [_c('h3', [_vm._v("弹性子元素的属性说明")]), _c('ul', _vm._l((_vm.itemDescArr), function(desc) {
    return _c('li', [_vm._v(_vm._s(desc))])
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_vm._v("弹性容器属性设置"), _c('span', {
    staticClass: "one-more-thing"
  }, [_vm._v("第一个为默认值！")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09483f1b"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ctrl.vue
// module id = 95
// module chunks = 1